import { mapSearchModelToQueryString } from '@aviv-search/transformers';
export const PAGE_PARAM = 'page';
export const ORDER_PARAM = 'order';
export const LIST_NAME_PARAM = 'ln';
export const getQueryString = ({ searchModel, page, order, trackingMedium }, defaultOrder) => {
    const modelAsQueryString = mapSearchModelToQueryString(searchModel);
    const pageParam = !page || page === 1 ? '' : `&${PAGE_PARAM}=${page}`;
    const orderParam = !order || order === defaultOrder ? '' : `&${ORDER_PARAM}=${order}`;
    const trackingMediumParam = trackingMedium ? `&m=${trackingMedium}` : '';
    return `${modelAsQueryString}${pageParam}${orderParam}${trackingMediumParam}`;
};
